import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pageSamples } from '../data/content';
export function InsidePages() {
  const [index, setIndex] = useState<number>(0);
  const [direction, setDirection] = useState<number>(1);
  const total = pageSamples.length;
  const current = pageSamples[index];
  const go = (next: number) => {
    setDirection(next > index ? 1 : -1);
    setIndex((next + total) % total);
  };
  return <section id="inside-pages" className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-117" data-mp="31xnaxe76rbgu">
      <div className="mx-auto max-w-5xl" data-id="element-118" data-mp="2x52gqbkdawcs">
        <div className="mx-auto max-w-2xl text-center" data-id="element-119" data-mp="2x416g9b6edw4">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-120" data-mp="2s7kibf3z7zj1">
            Sfoglia il materiale
          </span>
          <h2 className="mt-5 font-display text-[1.8rem] font-black leading-tight tracking-tight text-ink sm:text-[2.6rem]" data-id="element-121" data-mp="3pnhj3igk8bur">
            Guarda le pagine{' '}
            <span className="italic text-brand" data-id="element-122" data-mp="1mm2uxxk051et">dall&apos;interno.</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-123" data-mp="1rlyyxwsp8sud">
            Pagine reali del pacchetto, dai primi vocaboli A1 alle griglie di
            valutazione C1.
          </p>
        </div>

        <div className="mt-12 grid gap-8 md:grid-cols-[minmax(0,1fr)_18rem] md:items-center" role="group" aria-roledescription="carosello" aria-label="Pagine di esempio del materiale" tabIndex={0} onKeyDown={event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(index + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(index - 1);
        }
      }} data-id="element-124" data-mp="1huuj6uv793yh">
          <div className="relative flex h-[26rem] items-center justify-center overflow-hidden rounded-3xl bg-white p-4 shadow-soft sm:h-[34rem] sm:p-6" data-id="element-125" data-mp="2p7d4krwaczz5">
            <AnimatePresence initial={false} mode="wait" custom={direction} data-id="element-126" data-mp="63eobv0t5jkg">
              <motion.img key={current.src} src={current.src} alt={`${current.title} — pagina di esempio, livello ${current.level}`} custom={direction} initial={{
              opacity: 0,
              x: direction * 32
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: direction * -32
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} className="h-full w-full object-contain" data-id="element-127" data-mp="12r17kfp9mvi" />
            </AnimatePresence>

            <button type="button" onClick={() => go(index - 1)} aria-label="Pagina precedente" className="absolute left-3 top-1/2 inline-flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-ink/85 text-white transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-128" data-mp="fyezyu291hs0">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-129" data-mp="1g14qa8n6a0li" />
            </button>
            <button type="button" onClick={() => go(index + 1)} aria-label="Pagina successiva" className="absolute right-3 top-1/2 inline-flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-ink/85 text-white transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-130" data-mp="1kyda0dnyycov">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-131" data-mp="28p0t7v3c4oqq" />
            </button>
          </div>

          <div className="flex flex-col" data-id="element-132" data-mp="2cqvsyv5mau2e">
            <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-133" data-mp="2cs6zh2qg6fx7">
              {current.level}
            </p>
            <h3 className="mt-2 font-display text-xl font-bold leading-snug text-ink" data-id="element-134" data-mp="2hncnc73eu4nx">
              {current.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-ink/60" data-id="element-135" data-mp="2026c0hns7gnv">
              {current.caption}
            </p>
            <p className="mt-5 text-xs font-bold tabular-nums text-ink/40" data-id="element-136" data-mp="2drgjplhgngkm">
              {index + 1} / {total}
            </p>

            <ul className="mt-6 flex gap-3 overflow-x-auto pb-2 md:flex-wrap md:overflow-visible" data-id="element-137" data-mp="28vrrk37rt1yc">
              {pageSamples.map((page, pageIndex) => <li key={page.src} data-id="element-138" data-mp="1h3agn306sw8g" data-mpi={pageIndex}>
                  <button type="button" onClick={() => go(pageIndex)} aria-label={`Vai a ${page.title}`} aria-current={pageIndex === index} className={`h-16 w-12 shrink-0 overflow-hidden rounded-lg border-2 bg-white transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 ${pageIndex === index ? 'border-brand' : 'border-ink/10 hover:border-ink/30'}`} data-id="element-139" data-mp="1h4butgci1yue">
                    <img src={page.src} alt="" className="h-full w-full object-cover object-top" data-id="element-140" data-mp="s7biu6aafain" />
                  </button>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}